import React, { useState, useEffect } from 'react';
import CommonMessage from "../components/CommonMessage";
import { contractCall, web3AccountCheck } from '../helper/web3helper';
import hostContract from '../web3/hostContract.json';
import web3Config from '../web3/web3Config.json';
import { formatEmailDetails, formatMessageList } from '../helper/dataFormatHelper';
import Cookies from "universal-cookie";
import { useSelector, useDispatch } from 'react-redux';
import { getDecryptedContentFromIndexedDb } from "../db/indexed-helper";
import { getHostContract, getHostHelperContract } from "../helper/contract-helper.js";
import { getWeb2emails } from "../helper/dataFormatHelper.js"
import { getEmails, getSentEmails } from '../helper/emailHelper.js';
import { reportError, toErrorString } from '../utils/errorLogger.js';
const cookies = new Cookies();

const Folders = () => {
  const [user] = useState(cookies.get("userObject"));
  const [web3Value, setWeb3] = useState(null);
  const [account, setAccount] = useState('');
  const [web3Contract, setWeb3Contract] = useState('');
  const [allBoxList, setAllBoxList] = useState([]);
  const [readList, setReadList] = useState([]);
  const [unreadList, setUnreadList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [rendered, setRendered] = useState(false);
  const [text, setText] = useState("")
  const userName = user.name;
  const getFolderIndex = useSelector((state) => state.folderIndex);

  useEffect(() => {
    web3AccountCheck(setWeb3, setAccount);
  }, []);

  useEffect(() => {
    if (account && web3Value) {
      // const contractInstance = new web3Value.eth.Contract(hostContract.contract, web3Config.CONTRACT);
      const contractInstance = contractCall(hostContract.contract, web3Config.CONTRACT);
      setWeb3Contract(contractInstance);
    }
  }, [web3Value, account]);


  useEffect(() => {
    if (web3Contract) {
      setEmail(true);
    }
  }, [web3Contract, getFolderIndex]);



  useEffect(() => {
    if (web3Contract) {
      setEmail();
    }
  }, []);


  const reRender = () => {
    setEmail();
  }


  async function setEmail(loaderRequired = true) {

    try {

      if (!web3Contract) return;

      if (loaderRequired) {
        setLoader(true);
        setText("Please wait, data is loading from the blockchain, Going forward it will be fast.")
        setRendered(false);
      }
      const response = await getWeb2emails(userName);
      const hostContract = getHostContract();
      const helperContract = getHostHelperContract();
      const folderRecords = await getEmails(userName);
      const sentfolderRecords = await getSentEmails(userName);
      const result = await helperContract.methods.getAttributes(userName).call();

      const web2emails = response.filter((email) => {
        const value = result.some((data) =>
          data.attType === "folder" &&
          data.key === `inbox-folder-${parseInt(localStorage.getItem('selectedFolderId'))}` &&
          parseInt(email.physmessage_id) === parseInt(data.id) && data.value === true
        );
        return value;
      });


      const folderId = localStorage.getItem('selectedFolderId') ?? '';
      const filterWeb2emails = web2emails.filter(data => data.delete !== 1 && data.delete !== 3)
      const formatInboxFolder = await formatEmailDetails(folderRecords);
      const formattedResult = formatInboxFolder
        .filter(email => email.senderName && folderId === email.folder)
        .map(email => ({
          id: parseInt(email.id),
          subject: email.subject,
          encryptedData: email.encryptedData,
          created_at: email.receivedDate,
          isStarred: email.isStarred,
          sender: email.senderName,
          isRead: email.isRead,
          header: email.emailDetails,
          isCC: email.isCC,
          isBCC: email.isBCC,
          emailType: 'inbox',
          ...email
        })).filter(data => !data.attributes.value && !data.isDeleted && !data.isArchive && !data.isSaved);

      const formatSentFolder = await formatEmailDetails(sentfolderRecords);
      const sentformattedResult = formatSentFolder
        .filter(email => email.receiver && folderId === email.folder)
        .map(email => ({
          id: parseInt(email.id),
          subject: email.subject,
          encryptedData: email.encryptedData,
          created_at: email.receivedDate,
          isStarred: false,
          sender: email.sender,
          isRead: true,
          header: email.receiver,
          emailType: 'sent',
          ...email
        })).filter(data => !data.attributes.value && !data.isDeleted && !data.isArchive);
      const filteredValue = formattedResult.concat(sentformattedResult);
      for (let list of filteredValue) {
        const decryptedMessage = await getDecryptedContentFromIndexedDb(parseInt(list.id), 'folders');
        list.decryptedMessage = decryptedMessage
      }
      const list = await formatMessageList(filteredValue.reverse());
      const filterEmails = list.allList.concat(filterWeb2emails).sort((a, b) => new Date(b.date) - new Date(a.date))
      const readListAllEmails = filterEmails.filter(message => message.isRead);
      const unReadListAllEmails = filterEmails.filter(message => !message.isRead);
      setAllBoxList(filterEmails);
      setReadList(readListAllEmails.sort((a, b) => new Date(b.date) - new Date(a.date)));
      setUnreadList(unReadListAllEmails.sort((a, b) => new Date(b.date) - new Date(a.date)));
      if (loaderRequired) {
        setRendered(true);
      }
    } catch (error) {
      const errorStr = toErrorString(error || error.message);
      const userName = localStorage.getItem('UserName');
      reportError({
        endpoint: '-',
        message: `FileName: Folder.js, Fun: setEmail, ${String(error.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
      setLoader(false);
      setText("")
      console.log("error", error);
    }
  }

  useEffect(() => {
    if (rendered) {
      setLoader(false)
      setText("")
    }
  }, [rendered]);


  return (
    <div className="inbox-container">
      <CommonMessage messageList={allBoxList} pageType={"Folders"} unreadList={unreadList} loader={loader} readList={readList} reRender={reRender} text={text} />
    </div>
  );
}


export default Folders
